( function () {
	'use strict';
	/* eslint max-params:0 */
	/* eslint-disable max-params */
	function DashboardCtrl ( $q, logger, createObsService, layoutFactory ) {
		var self   = this;

		self.title = 'Dashboard';

		var preloadData = $q.all( [
			createObsService.getTemplates(),
			createObsService.getFavoriteTemplates(),
			createObsService.getSchoolsAndUsers()
		] );

		self.widgets = [
			{
				'title' : 'Observations',
				'icon'  : 'icon4-observation'
			},
			{
				'title' : 'Schedule',
				'icon'  : 'calendar-icon'
			},
			{
				'title' : 'Templates',
				'icon'  : 'icon5-template'
			},
			{
				'title' : 'Reports',
				'icon'  : 'reports-icon'
			}
		];

		self.deviceWidgets = [
			{
				'title' : 'Observations',
				'icon'  : 'icon4-observation'
			},
			{
				'title' : 'Schedule',
				'icon'  : 'calendar-icon'
			},
			{
				'title' : 'Templates',
				'icon'  : 'icon5-template'
			}
		];

		self.actions = [
			{
				'title' : 'Perform an Observation',
				'level' : 0,
				'fn'    : 'startObsModal'
			},
			{
				'title' : 'View In-Progress Observations',
				'level' : 0,
				'fn'    : 'redirectObsList'
			},
			{
				'title' : 'View Completed Observations',
				'level' : 0,
				'fn'    : 'redirectObsList'
			},
			{
				'title' : 'Schedule an Observation',
				'level' : 1,
				'fn'    : 'schedObsModal'
			},
			{
				'title' : 'Schedule a Meeting',
				'level' : 1,
				'fn'    : 'schedObsModal'
			},
			{
				'title' : 'View Schedule',
				'level' : 1,
				'fn'    : 'redirectCalendar'
			},
			{
				'title' : 'Create a Template',
				'level' : 2,
				'fn'    : 'createTempModal'
			},
			{
				'title' : 'View All Templates',
				'level' : 2,
				'fn'    : 'redirectTempList'
			},
			{
				'title' : 'View Favorite Templates',
				'level' : 2,
				'fn'    : 'redirectTempList'
			},
			{
				'title' : 'Results by Item Report',
				'level' : 3,
				'fn'    : 'redirectReportFirstLink',
				'isNew' : true
			},
			{
				'title' : 'Data Export Report',
				'level' : 3,
				'fn'    : 'redirectReportSecondLink'
			},
			{
				'title' : 'View All Reports',
				'level' : 3,
				'fn'    : 'redirectReport'
			}
		];

		createObsService.savePreLoadedData( preloadData );

		function activate () {
			logger.info( 'Activated Dashboard View' );
			self.mobileDevice = layoutFactory.checkPlatform();
		}

		activate();
	}

	function run ( $rootScope, $location, $window, Session ) {
		$rootScope.$on( '$locationChangeStart', function () {
			// If you want to test something is working in a development environment,
			// replace the analytic create call with the one commented below.
			// ga( 'create', 'UA-21912624-11', {
			// 	'cookieDomain' : 'none'
			// } );

			/* global ga */
			if ( $window.ga ) {
				var cred = Session.getCredentials() || { 'userId' : '' };

				ga( 'create', 'UA-21912624-11', 'auto', {
					'userId' : cred.userId
				} );

				$rootScope.$on( '$viewContentLoaded', function () {
					$window.ga( 'set', 'userId', cred.userId );
					$window.ga( 'send', 'pageview', {
						'page' : '/#' + $location.url()
					} );
				} );
			}
		} );
	}

	angular
		.module( 'app.dashboard' )
		.controller( 'DashboardCtrl', DashboardCtrl )
		.run( run );

	run.$inject = [ '$rootScope', '$location', '$window', 'Session' ];
	DashboardCtrl.$inject = [ '$q', 'logger', 'createObsService', 'layoutFactory' ];
} )( );
